import { MiddlewareAction } from "../middleware";
import {
  AuditLogListQuery,
  CreatePreApprovalRequest,
  ExpirePreApprovalRequest,
  CreateCreditDecisionPricingRequest,
  ManualOverrideRequest,
  PreApprovalListQuery,
} from "../models/creditDecision";
export enum CreditDecisionActions {
  REQUEST_LIST_AUDIT_LOGS = "REQUEST_LIST_AUDIT_LOGS",
  REQUEST_GET_AUDIT_LOG = "REQUEST_GET_AUDIT_LOG",
  REQUEST_CREATE_PRE_APPROVAL = "REQUEST_CREATE_PRE_APPROVAL",
  REQUEST_EXPIRE_PRE_APPROVAL = "REQUEST_EXPIRE_PRE_APPROVAL",
  REQUEST_CREATE_PRICING = "REQUEST_CREATE_PRICING",
  REQUEST_LIST_PRICINGS = "REQUEST_LIST_PRICINGS",
  REQUEST_GET_PRICING = "REQUEST_GET_PRICING",
  REQUEST_LIST_PRE_APPROVALS = "REQUEST_LIST_PRE_APPROVALS",
  REQUEST_MANUAL_OVERRIDE = "REQUEST_MANUAL_OVERRIDE",
}

// Audit Logs
export function listAuditLogs(query: AuditLogListQuery): MiddlewareAction {
  return {
    actionName: CreditDecisionActions.REQUEST_LIST_AUDIT_LOGS,
    type: "GET",
    url: "/v1/credit-decision/audit-logs",
    queryParams: query as Record<string, any>,
    throwOnError: true,
  };
}

export function getAuditLog(id: string): MiddlewareAction {
  return {
    actionName: CreditDecisionActions.REQUEST_GET_AUDIT_LOG,
    type: "GET",
    url: `/v1/credit-decision/audit-logs/${id}`,
    throwOnError: true,
  };
}

// Pre-Approvals
export function listPreApprovals(query?: PreApprovalListQuery): MiddlewareAction {
  return {
    actionName: CreditDecisionActions.REQUEST_LIST_PRE_APPROVALS,
    type: "GET",
    url: "/v1/credit-decision/pre-approval",
    queryParams: query as Record<string, any>,
  };
}

export function createPreApproval(payload: CreatePreApprovalRequest): MiddlewareAction {
  return {
    actionName: CreditDecisionActions.REQUEST_CREATE_PRE_APPROVAL,
    type: "POST",
    url: "/v1/credit-decision/pre-approval",
    body: payload,
  };
}

export function expirePreApproval(
  preApprovalId: string,
  payload: ExpirePreApprovalRequest
): MiddlewareAction {
  return {
    actionName: CreditDecisionActions.REQUEST_EXPIRE_PRE_APPROVAL,
    type: "PATCH",
    url: `/v1/credit-decision/pre-approval/${preApprovalId}/expire`,
    body: payload,
  };
}

// Pricing
export function createPricing(payload: CreateCreditDecisionPricingRequest): MiddlewareAction {
  return {
    actionName: CreditDecisionActions.REQUEST_CREATE_PRICING,
    type: "POST",
    url: "/v1/credit-decision/pricing",
    body: payload,
  };
}

export function listPricings(query?: { name?: string; limit?: number; cursor?: string }): MiddlewareAction {
  return {
    actionName: CreditDecisionActions.REQUEST_LIST_PRICINGS,
    type: "GET",
    url: "/v1/credit-decision/pricing",
    queryParams: query as Record<string, any>,
  };
}

export function getPricing(pricingId: string): MiddlewareAction {
  return {
    actionName: CreditDecisionActions.REQUEST_GET_PRICING,
    type: "GET",
    url: `/v1/credit-decision/pricing/${pricingId}`,
  };
}

// Manual Override
export function manualOverride(
  applicationId: string,
  payload: ManualOverrideRequest
): MiddlewareAction {
  return {
    actionName: CreditDecisionActions.REQUEST_MANUAL_OVERRIDE,
    type: "PATCH",
    url: `/term-loan-application/${applicationId}/manual-override`,
    body: payload,
  };
}
